/* =====================================================
   Creating Balloons & Gifts — Animations JS
   Vanilla JS — works inside Dawn + listens for
   shopify:section:load to reinitialise on editor edits
   ===================================================== */

(function () {
  'use strict';

  const PALETTE = ['#5a9fd4', '#9fcfe8', '#2d76ab', '#cfe6f2', '#dde6f8', '#eef6fc', '#7fc2ef', '#5468b8'];
  const reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---- SVG generators ---- */
  function balloonSVG(color, size, noString) {
    const w = size, h = Math.round(size * 1.5);
    return `<svg width="${w}" height="${h}" viewBox="0 0 60 90">
      ${noString ? '' : '<path d="M30 60 C30 66 31 74 30 82" stroke="#cdd6e2" stroke-width="1.4" fill="none"/>'}
      <ellipse cx="30" cy="32" rx="25" ry="30" fill="${color}"/>
      <path d="M27 60 l3 5 l3 -5 z" fill="${color}"/>
      <ellipse cx="21" cy="20" rx="5" ry="9" fill="#fff" opacity=".55" transform="rotate(-18 21 20)"/>
      <ellipse cx="17" cy="33" rx="2.2" ry="4" fill="#fff" opacity=".4" transform="rotate(-18 17 33)"/>
    </svg>`;
  }
  function flowerSVG(c, size) {
    let petals = '';
    for (let k = 0; k < 6; k++) petals += `<ellipse cx="30" cy="13" rx="7.5" ry="12" fill="${c}" transform="rotate(${k * 60} 30 30)"/>`;
    return `<svg width="${size}" height="${size}" viewBox="0 0 60 60">${petals}<circle cx="30" cy="30" r="8.5" fill="#fbe7ad"/><circle cx="30" cy="30" r="8.5" fill="none" stroke="#fff" stroke-opacity=".55" stroke-width="1.4"/></svg>`;
  }
  function teddySVG(size) {
    const f = '#d8b894';
    return `<svg width="${size}" height="${size}" viewBox="0 0 60 60">
      <circle cx="16" cy="15" r="8" fill="${f}"/><circle cx="44" cy="15" r="8" fill="${f}"/>
      <circle cx="16" cy="15" r="4" fill="#f7c6ce"/><circle cx="44" cy="15" r="4" fill="#f7c6ce"/>
      <circle cx="30" cy="33" r="20" fill="${f}"/>
      <ellipse cx="30" cy="39" rx="9" ry="7.5" fill="#f3e6d4"/>
      <circle cx="22.5" cy="29" r="2.7" fill="#4a3a2a"/><circle cx="37.5" cy="29" r="2.7" fill="#4a3a2a"/>
      <ellipse cx="30" cy="36" rx="2.8" ry="2.1" fill="#4a3a2a"/>
      <path d="M30 38 Q26 42 23 40 M30 38 Q34 42 37 40" stroke="#4a3a2a" stroke-width="1.4" fill="none" stroke-linecap="round"/>
    </svg>`;
  }

  /* ---- Balloon helpers ---- */
  function makeBalloon(d, inflate) {
    const b = document.createElement('div');
    b.className = 'cb-balloon';
    b.style.left = d.x + '%';
    b.style.top = d.y + '%';
    b.dataset.speed = d.speed;
    b.dataset.mouse = d.mouse;
    b.dataset.float = d.float;
    b.style.opacity = d.op != null ? d.op : 1;
    const inner = document.createElement('div');
    inner.className = 'cb-balloon-inner' + (inflate ? ' cb-inflate' : '');
    inner.innerHTML = balloonSVG(d.color, d.size);
    b.appendChild(inner);
    return b;
  }

  /* ---- Hero balloons ---- */
  let rafId = null;
  let rafRunning = false;
  let balloons = [];
  let mx = 0, my = 0, tmx = 0, tmy = 0;
  let lastSy = window.scrollY, lag = 0;

  const HERO_DEFS = [
    { x: 78, y: 18, size: 90, color: '#5a9fd4', speed: .18, mouse: 26, float: 14, op: .82 },
    { x: 88, y: 42, size: 64, color: '#9fcfe8', speed: .30, mouse: 40, float: 18, op: .72 },
    { x: 70, y: 55, size: 120, color: '#2d76ab', speed: .10, mouse: 16, float: 10, op: .35 },
    { x: 60, y: 30, size: 52, color: '#cfe6f2', speed: .40, mouse: 50, float: 22, op: .68 },
    { x: 92, y: 72, size: 44, color: '#dde6f8', speed: .5, mouse: 60, float: 24, op: .6 },
    { x: 8, y: 64, size: 40, color: '#7fc2ef', speed: .45, mouse: 55, float: 20, op: .55 },
    { x: 30, y: 88, size: 70, color: '#cfe6f2', speed: .22, mouse: 30, float: 14, op: .45 },
    { x: 46, y: 6, size: 60, color: '#9fcfe8', speed: .36, mouse: 46, float: 20, op: .65 },
    { x: 64, y: 12, size: 40, color: '#eef6fc', speed: .48, mouse: 58, float: 22, op: .55 },
    { x: 96, y: 40, size: 54, color: '#5468b8', speed: .26, mouse: 36, float: 16, op: .65 },
    { x: 16, y: 90, size: 46, color: '#9fcfe8', speed: .4, mouse: 50, float: 20, op: .5 },
    { x: 38, y: 80, size: 36, color: '#cfe6f2', speed: .5, mouse: 60, float: 24, op: .45 },
  ];

  function initHeroBalloons() {
    const field = document.getElementById('cbHeroBalloons');
    if (!field) return;
    field.innerHTML = '';
    balloons = [];
    HERO_DEFS.forEach(d => {
      const b = makeBalloon(d);
      field.appendChild(b);
      balloons.push(b);
    });
  }

  function burstAt(b, size) {
    const fx = document.createElement('div');
    fx.className = 'cb-burst';
    fx.style.left = (size / 2) + 'px';
    fx.style.top = (size * 0.5) + 'px';
    const cols = ['#5a9fd4', '#cfe6f2', '#dde6f8', '#9fcfe8', '#5468b8'];
    for (let k = 0; k < 9; k++) {
      const i = document.createElement('i');
      const ang = (Math.PI * 2 * k) / 9 + Math.random() * .5;
      const dist = 30 + Math.random() * 30;
      i.style.setProperty('--dx', Math.cos(ang) * dist + 'px');
      i.style.setProperty('--dy', Math.sin(ang) * dist + 'px');
      i.style.background = cols[k % cols.length];
      fx.appendChild(i);
    }
    b.appendChild(fx);
    requestAnimationFrame(() => fx.classList.add('go'));
    setTimeout(() => fx.remove(), 780);
  }

  function spawnHeroBalloon() {
    const field = document.getElementById('cbHeroBalloons');
    if (!field) return;
    const size = 38 + Math.round(Math.random() * 72);
    let x = Math.random() < 0.8 ? 52 + Math.random() * 42 : 18 + Math.random() * 26;
    let y = (x < 46) ? 76 + Math.random() * 14 : 10 + Math.random() * 78;
    const def = { x, y, size, color: PALETTE[Math.floor(Math.random() * PALETTE.length)], speed: .12 + Math.random() * .38, mouse: 22 + Math.random() * 40, float: 10 + Math.random() * 14, op: .55 + Math.random() * .4 };
    const b = makeBalloon(def, true);
    field.appendChild(b);
    balloons.push(b);
  }

  function popHero() {
    const field = document.getElementById('cbHeroBalloons');
    if (!field) return;
    const cand = [...field.querySelectorAll('.cb-balloon')].filter(b => !b.dataset.busy);
    if (cand.length > 4) {
      const b = cand[Math.floor(Math.random() * cand.length)];
      b.dataset.busy = '1';
      const svg = b.querySelector('svg');
      burstAt(b, parseFloat(svg.getAttribute('width')) || 60);
      const inner = b.querySelector('.cb-balloon-inner');
      inner.classList.remove('cb-inflate');
      inner.classList.add('cb-pop');
      setTimeout(() => {
        const idx = balloons.indexOf(b);
        if (idx >= 0) balloons.splice(idx, 1);
        b.remove();
        spawnHeroBalloon();
      }, 470);
    }
    scheduleHeroPop();
  }
  function scheduleHeroPop() { setTimeout(popHero, 2600 + Math.random() * 2600); }

  /* ---- Animation loop ---- */
  window.addEventListener('mousemove', e => {
    tmx = (e.clientX / window.innerWidth - .5) * 2;
    tmy = (e.clientY / window.innerHeight - .5) * 2;
  });

  function frame(t) {
    mx += (tmx - mx) * .06;
    my += (tmy - my) * .06;
    const sy = window.scrollY;
    balloons.forEach((b, i) => {
      const sp = parseFloat(b.dataset.speed), ms = parseFloat(b.dataset.mouse), fl = parseFloat(b.dataset.float);
      const py = -sy * sp;
      const fx = reduce ? 0 : Math.sin(t / 1400 + i) * fl * .4;
      const fy = reduce ? 0 : Math.cos(t / 1200 + i * 1.3) * fl;
      const rot = reduce ? 0 : Math.sin(t / 2000 + i) * 4;
      b.style.transform = `translate(${(-mx * ms) + fx}px,${py + (-my * ms * .5) + fy}px) rotate(${rot}deg)`;
    });
    /* follow balloon — movimiento + color según scroll */
    const follow = document.getElementById('cbFollowBalloon');
    if (follow) {
      const dv = sy - lastSy; lastSy = sy;
      lag = lag * 0.86 + dv * 0.45;
      lag = Math.max(-90, Math.min(90, lag));
      const fbx = reduce ? 0 : Math.sin(t / 1500) * 10 - mx * 22;
      const fby = reduce ? 0 : Math.cos(t / 1100) * 12 + lag;
      const fbr = reduce ? 0 : Math.sin(t / 1800) * 5 + lag * 0.06;
      follow.style.transform = `translate(${fbx}px,${fby}px) rotate(${fbr}deg)`;
      /* color cambia suavemente según posición de scroll */
      const maxScroll = Math.max(document.body.scrollHeight - window.innerHeight, 1);
      const hue = Math.round((sy / maxScroll) * 300);
      follow.style.filter = `drop-shadow(0 14px 18px rgba(46,140,140,.28)) hue-rotate(${hue}deg)`;
    }
    rafId = requestAnimationFrame(frame);
  }

  function startRAF() {
    if (rafRunning) return;
    rafRunning = true;
    rafId = requestAnimationFrame(frame);
  }

  /* ---- Follow balloon ---- */
  function initFollowBalloon() {
    const follow = document.getElementById('cbFollowBalloon');
    if (!follow) return;
    const size = window.innerWidth <= 680 ? 48 : 74;
    follow.innerHTML = balloonSVG('#5a9fd4', size);
  }

  /* ---- Balloon arch (Welcome section) ---- */
  const ARCH = [
    { t: 0.00, s: 46, c: '#cfe6f2', o: 34 },
    { t: 0.05, s: 64, c: '#5a9fd4', o: 10 },
    { t: 0.10, s: 40, c: '#fbe7ad', o: 46 },
    { t: 0.16, s: 74, c: '#5468b8', o: -8 },
    { t: 0.22, s: 48, c: '#f7c6ce', o: 30, type: 'flower' },
    { t: 0.28, s: 86, c: '#9fcfe8', o: -22 },
    { t: 0.35, s: 54, c: '#5a9fd4', o: 20, type: 'teddy' },
    { t: 0.42, s: 78, c: '#2d76ab', o: -30 },
    { t: 0.50, s: 96, c: '#5a9fd4', o: -40 },
    { t: 0.58, s: 52, c: '#f7c6ce', o: 18 },
    { t: 0.64, s: 80, c: '#5468b8', o: -28 },
    { t: 0.71, s: 50, c: '#9fcfe8', o: 24, type: 'flower' },
    { t: 0.78, s: 84, c: '#9fcfe8', o: -18 },
    { t: 0.85, s: 48, c: '#fbe7ad', o: 34 },
    { t: 0.91, s: 66, c: '#2d76ab', o: 6 },
    { t: 0.97, s: 42, c: '#f7c6ce', o: 42 },
  ];

  function buildArch(el) {
    el.innerHTML = '';
    ARCH.forEach((b, i) => {
      const rise = Math.sin(b.t * Math.PI);
      const top = 86 - rise * 150 + b.o;
      const d = document.createElement('div');
      d.className = 'cb-ab';
      d.style.left = `calc(${(b.t * 100).toFixed(2)}% - ${b.s / 2}px)`;
      d.style.top = top + 'px';
      d.style.zIndex = b.type ? 120 : Math.round(b.s);
      d.style.transitionDelay = (0.04 * i) + 's';
      d.innerHTML = b.type === 'flower' ? flowerSVG(b.c, b.s) : b.type === 'teddy' ? teddySVG(b.s) : balloonSVG(b.c, b.s);
      el.appendChild(d);
    });
  }

  function initArch() {
    const archEl = document.getElementById('cbWelcomeArch');
    if (!archEl) return;
    buildArch(archEl);
    new IntersectionObserver((ents, ob) => {
      ents.forEach(en => {
        if (en.isIntersecting) { archEl.classList.add('in'); ob.disconnect(); }
      });
    }, { threshold: .2 }).observe(archEl.parentElement);
  }

  /* ---- Separator (hanging balloons) ---- */
  const SEP_DATA = [
    { s: 46, c: '#cfe6f2' }, { s: 58, c: '#9fcfe8' }, { s: 50, c: '#f7c6ce' }, { s: 66, c: '#5a9fd4' },
    { s: 52, c: '#fbe7ad' }, { s: 68, c: '#5468b8' }, { s: 50, c: '#f7c6ce' }, { s: 60, c: '#2d76ab' },
    { s: 46, c: '#cfe6f2' }, { s: 56, c: '#9fcfe8' }, { s: 48, c: '#fbe7ad' }
  ];
  const SEP_CORDS = [40, 22, 34, 16, 30, 12, 30, 18, 36, 24, 42];

  function initSeparator() {
    const sepWave = document.getElementById('cbSepWave');
    if (!sepWave) return;
    sepWave.innerHTML = '';
    const bulbs = [];
    SEP_DATA.forEach((b, i) => {
      const wrap = document.createElement('div');
      wrap.className = 'cb-sep-balloon';
      wrap.style.setProperty('--cord', SEP_CORDS[i] + 'px');
      wrap.style.animationDelay = (-i * 0.34) + 's';
      wrap.style.animationDuration = (3.8 + (i % 3) * 0.5) + 's';
      const cord = document.createElement('div'); cord.className = 'cb-sep-cord';
      const bulb = document.createElement('div'); bulb.className = 'cb-sep-bulb';
      bulb.dataset.color = b.c; bulb.dataset.size = b.s;
      bulb.innerHTML = balloonSVG(b.c, b.s, true);
      wrap.appendChild(cord); wrap.appendChild(bulb);
      sepWave.appendChild(wrap);
      bulbs.push(bulb);
    });
    if (reduce) return;
    function burstSep(bulb) {
      const wrap = bulb.parentElement;
      const fx = document.createElement('div'); fx.className = 'cb-sep-burst';
      const cols = ['#5a9fd4', '#f7c6ce', '#fbe7ad', '#9fcfe8', '#5468b8'];
      for (let k = 0; k < 8; k++) {
        const i = document.createElement('i');
        const ang = (Math.PI * 2 * k) / 8 + Math.random() * .5;
        const dist = 26 + Math.random() * 22;
        i.style.setProperty('--dx', Math.cos(ang) * dist + 'px');
        i.style.setProperty('--dy', (Math.sin(ang) * dist - 10) + 'px');
        i.style.background = cols[k % cols.length];
        fx.appendChild(i);
      }
      wrap.appendChild(fx);
      requestAnimationFrame(() => fx.classList.add('go'));
      setTimeout(() => fx.remove(), 720);
    }
    function popSep() {
      const free = bulbs.filter(b => !b.dataset.busy);
      if (free.length) {
        const bulb = free[Math.floor(Math.random() * free.length)];
        bulb.dataset.busy = '1';
        burstSep(bulb);
        bulb.classList.add('cb-sep-pop');
        setTimeout(() => {
          setTimeout(() => {
            bulb.classList.remove('cb-sep-pop');
            bulb.classList.add('cb-sep-inflate');
            setTimeout(() => { bulb.classList.remove('cb-sep-inflate'); delete bulb.dataset.busy; }, 860);
          }, 520);
        }, 420);
      }
      scheduleSep();
    }
    function scheduleSep() { setTimeout(popSep, 1900 + Math.random() * 2400); }
    scheduleSep();
  }

  /* ---- CTA Confetti ---- */
  function initCtaConfetti() {
    const cv = document.getElementById('cbCtaConfetti');
    if (!cv) return;
    const ctx = cv.getContext('2d');
    const COLORS = ['#9fcfe8', '#cfe6f2', '#dde6f8', '#eef6fc', '#ffffff', '#7fc2ef'];
    let pieces = [], W = 0, H = 0, raf2 = null, running = false;
    function resize() {
      const r = cv.getBoundingClientRect();
      W = cv.width = Math.max(1, Math.round(r.width));
      H = cv.height = Math.max(1, Math.round(r.height));
      const n = Math.round(W / 26);
      pieces = [];
      for (let i = 0; i < n; i++) pieces.push(spawn(true));
    }
    function spawn(init) {
      return { x: Math.random() * W, y: init ? Math.random() * H : -12, s: 5 + Math.random() * 7, vy: 14 + Math.random() * 22, vx: (Math.random() - .5) * 16, rot: Math.random() * Math.PI * 2, vr: (Math.random() - .5) * 2.4, sway: 0.6 + Math.random() * 1.2, phase: Math.random() * Math.PI * 2, shape: Math.random() < .5 ? 'rect' : (Math.random() < .5 ? 'circle' : 'strip'), col: COLORS[Math.floor(Math.random() * COLORS.length)], alpha: .5 + Math.random() * .45 };
    }
    let last = performance.now();
    function frameConf(t) {
      const dt = Math.min(.05, (t - last) / 1000); last = t;
      ctx.clearRect(0, 0, W, H);
      for (const p of pieces) {
        p.y += p.vy * dt; p.phase += p.sway * dt; p.x += p.vx * dt + Math.sin(p.phase) * 8 * dt; p.rot += p.vr * dt;
        if (p.y > H + 14) { Object.assign(p, spawn(false)); }
        ctx.save(); ctx.globalAlpha = p.alpha; ctx.translate(p.x, p.y); ctx.rotate(p.rot); ctx.fillStyle = p.col;
        if (p.shape === 'circle') { ctx.beginPath(); ctx.arc(0, 0, p.s * .5, 0, Math.PI * 2); ctx.fill(); }
        else if (p.shape === 'strip') { ctx.fillRect(-p.s * .3, -p.s * .9, p.s * .6, p.s * 1.8); }
        else { ctx.fillRect(-p.s * .5, -p.s * .5, p.s, p.s); }
        ctx.restore();
      }
      raf2 = requestAnimationFrame(frameConf);
    }
    function start() { if (running || reduce) return; running = true; last = performance.now(); raf2 = requestAnimationFrame(frameConf); }
    function stop() { running = false; if (raf2) cancelAnimationFrame(raf2); }
    resize();
    window.addEventListener('resize', resize);
    new IntersectionObserver(es => es.forEach(e => e.isIntersecting ? start() : stop()), { threshold: .05 }).observe(cv.parentElement);
    if (reduce) { for (const p of pieces) { ctx.save(); ctx.globalAlpha = p.alpha; ctx.translate(p.x, p.y); ctx.fillStyle = p.col; ctx.beginPath(); ctx.arc(0, 0, p.s * .5, 0, Math.PI * 2); ctx.fill(); ctx.restore(); } }
  }

  /* ---- Scroll reveal ---- */
  function initReveal() {
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.cb-reveal').forEach(el => io.observe(el));
  }

  /* ---- Header scroll + mobile menu ---- */
  function initHeader() {
    const header = document.getElementById('cbHeader');
    if (!header) return;

    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const navPanel = document.getElementById('cbNavLinks');
    const menuToggle = document.getElementById('cbMenuToggle');
    const menuClose = document.getElementById('cbMenuClose');
    const overlay = document.getElementById('cbNavOverlay');

    /* Move panel + overlay to <body> — escape any parent stacking context */
    if (navPanel && navPanel.parentElement !== document.body) document.body.appendChild(navPanel);
    if (overlay && overlay.parentElement !== document.body) document.body.appendChild(overlay);

    /* Overlay controlled by inline styles — no CSS class/media-query dependency */
    function showOverlay() {
      if (!overlay) return;
      overlay.style.display = 'block';
      overlay.style.opacity = '0';
      overlay.style.transition = 'opacity 0.3s ease';
      requestAnimationFrame(() => { overlay.style.opacity = '1'; });
    }
    function hideOverlay() {
      if (!overlay) return;
      overlay.style.opacity = '0';
      setTimeout(() => { overlay.style.display = 'none'; }, 300);
    }

    function openMenu() {
      if (!navPanel) return;
      navPanel.style.display = 'flex';
      requestAnimationFrame(() => navPanel.classList.add('open'));
      showOverlay();
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }
    function resetSubPanels() {
      navPanel.querySelectorAll('.cb-mpanel:not(.cb-mpanel--main)').forEach(p => p.classList.remove('cb-mpanel--active'));
    }

    function closeMenu() {
      if (!navPanel) return;
      navPanel.classList.remove('open');
      hideOverlay();
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      resetSubPanels();
    }

    if (!menuToggle || !navPanel) return;

    menuToggle.addEventListener('click', () =>
      navPanel.classList.contains('open') ? closeMenu() : openMenu()
    );

    /* Cierre: botón X, links, overlay, Escape */
    if (menuClose) menuClose.addEventListener('click', closeMenu);
    navPanel.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));

    if (overlay) {
      overlay.addEventListener('click', closeMenu);
      overlay.addEventListener('touchend', function(e) { e.preventDefault(); closeMenu(); });
    }

    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });

    /* Mobile sub-panel navigation */
    navPanel.querySelectorAll('.cb-mpanel-parent').forEach(btn => {
      btn.addEventListener('click', e => {
        e.stopPropagation();
        const target = document.getElementById(btn.dataset.panel);
        if (target) target.classList.add('cb-mpanel--active');
      });
    });

    navPanel.querySelectorAll('.cb-mpanel-back').forEach(btn => {
      btn.addEventListener('click', () => {
        btn.closest('.cb-mpanel').classList.remove('cb-mpanel--active');
      });
    });
  }

  /* ---- Init all ---- */
  function initAll() {
    initFollowBalloon();
    initHeroBalloons();
    if (!reduce) scheduleHeroPop();
    startRAF();
    initSeparator();
    initCtaConfetti();
    initReveal();
    initHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Reinit on Shopify editor section load */
  document.addEventListener('shopify:section:load', function (e) {
    initAll();
  });

  window.addEventListener('resize', function () {
    const field = document.getElementById('cbHeroBalloons');
    if (field) initHeroBalloons();
  });

})();
